(() => {
  const initCollection = (root) => {
    if (root.dataset.scReady === 'true') return;
    root.dataset.scReady = 'true';
    root.querySelector('[data-sc-sort]')?.addEventListener('change', (event) => event.target.form.submit());
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-sc-collection]').forEach(initCollection);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
